import React from 'react';
import { Box, Grid, Text, Heading } from 'grommet';
import gridData from '../../data/governance/OwnershipModelData.json';

export const OwnershipModelGrid = () => {
  // Calculate the maximum number of values in any subject across all root objects
  const getMaxValuesLength = () => {
    let maxValuesLength = 0;
    Object.values(gridData).forEach((rootItem) => {
      const { subjects } = rootItem;
      
      subjects.forEach((subject) => {
        const valuesLength = subject.values.length;
        if (valuesLength > maxValuesLength) {
          maxValuesLength = valuesLength;
        }
      });
    });
    return maxValuesLength;
  };

  const numColumns = getMaxValuesLength() + 1;  // Add 1 column for the root column (column 1)

  // Calculate the number of rows: one row for root title and the number of rows equal to the number of subjects
  const numRows = Object.values(gridData).reduce(
    (total, rootItem) => total + rootItem.subjects.length, // Number of rows based on subjects
    0
  ); // Total rows should match the number of subjects (one row per subject)

  // Temporary function to handle box click...
  const handleBoxClick = (e) => {
    alert('Coming soon...');
    e.target.blur(); // Remove the focus (and thus the border)
  };

  const renderGridRows = () => {
    const rows = [];
    let rowIndex = 1; // Start at the first row

    // For each root item (Customer, IT, CDRM)
    Object.entries(gridData).forEach(([rootKey, rootItem]) => {
      const { title, description, subjects, color } = rootItem;

      // Root title spans rows based on the number of subjects...
      rows.push(
        <Box
          key={`${rootKey}-title`}
          gridArea={`${rowIndex} / 1 / ${rowIndex + subjects.length} / 1`} // Root title spans the entire rows of its subjects
          pad="small"
          background={color} 
          align="center"  // Center the content horizontally
          justify="center" // Center the content vertically
          style={{ minWidth: '250px' }} // Ensure minimum width for the first column
        >
          <Heading level={3} color="white" weight="bold" textAlign="center">{title}</Heading>
          <Text color="white" textAlign="center" style={{ whiteSpace: 'normal', overflow: 'visible' }}>
            {description}
          </Text>
        </Box>
      );

      // Now render each associated subject...
      subjects.forEach((subject, idx) => {
        const values = subject.values;

        // Single value subject spanning columns 2-N...
        if (values.length === 1) {
          rows.push(
            <Box
              key={`${rootKey}-subject-${idx}`}
              gridArea={`${rowIndex + idx} / 2 / ${rowIndex + idx + 1} / ${numColumns + 1}`} 
              pad="small"
              background={color}
              align="center" 
              justify="center" 
              onClick={handleBoxClick} 
              style={{ cursor: 'pointer', minWidth: '100px' }} // Ensure minimum width for subject boxes
            >
              <Text align="center" weight="bold" size="medium" color="white">{values[0]}</Text>  
            </Box>
          );
        } else {
          // Multiple values: wrap the columns 2-N in a Box and create a subgrid
          rows.push(
            <Box
              key={`${rootKey}-subject-row-${idx}`}
              gridArea={`${rowIndex + idx} / 2 / ${rowIndex + idx + 1} / ${numColumns + 1}`}
              pad="none" // Remove padding inside the container Box
              align="center"
              justify="center"
              fill // Ensure the Box fills the available space
 
            >
              {/* Sub-grid to fill the space from columns 2 to N */}
              <Grid
                columns={Array.from({ length: values.length }).map(() => '1fr')} // Equal column width for each cell
                gap="xxsmall" // Minimize the gap between grid items
                fill // Ensure the grid fills the space horizontally and vertically
                align="center"
                justify="center"
                style={{ margin: '0', height: '100%' }} // Remove margin from the Grid and ensure it takes full height
              >
                {values.map((value, valueIdx) => (
                  <Box
                    key={`${rootKey}-subject-${idx}-value-${valueIdx}`}
                    pad="small" // Remove padding inside each Box
                    background={color}
                    align="center"
                    justify="center"
                    onClick={handleBoxClick}
                    style={{ 
                      cursor: 'pointer', 
                      minWidth: '100px', 
                      width: '100%',
                      height: '100%' // Ensure each Box takes up full height
                    }}
                  >
                    <Text align="center" weight="bold" size="medium" color="white">{value}</Text>  
                  </Box>
                ))}
              </Grid>
            </Box>
          );
        }
      });

      // Update rowIndex after processing all subjects
      rowIndex += subjects.length;
    });

    return rows;
  };

  return (
    <Box pad="medium">
      <Grid
        rows={Array.from({ length: numRows }).map(() => 'auto')} // Adjust rows based on the data...
        columns={[ 
          '250px', // Max width for the first column...
          ...Array.from({ length: numColumns - 1 }).map(() => 'auto'), 
        ]}
        gap="xxsmall"
        overflow={{ horizontal: 'auto' }} 
      >
        {renderGridRows()}
      </Grid>
    </Box>
  );
};
